import { DEFAULT_FILTERS_CONFIGURATION } from 'shared-constants/src/filters';
import { NO_BUY_PTYPEGROUPS } from 'shared-constants/src/filters/utils';

const getFilterConfigurationKey = (filter) => {
  const filterNameLastChars = filter.slice(-3);
  const isMin = filterNameLastChars === 'Min';
  const isMax = filterNameLastChars === 'Max';
  const configurationKey = (isMin || isMax)
    ? filter.replace(filterNameLastChars, '')
    : filter;
  return {
    configurationKey,
    isMin,
    isMax,
  };
};

const getFilterDefaultValue = ({
  conf,
  isMin,
  isMax,
}) => {
  if (isMin) {
    return conf?.defaultMinValue;
  }
  if (isMax) {
    return conf?.defaultMaxValue;
  }
  return conf?.defaultValue;
};

const resetHiddenFilters = (filters) => {
  const filterKeys = Object.keys(filters);
  return filterKeys.reduce((acc, filter) => {
    const { configurationKey, isMin, isMax } = getFilterConfigurationKey(filter);
    const conf = DEFAULT_FILTERS_CONFIGURATION[configurationKey];
    const isHidden = conf?.isVisible && !conf.isVisible(filters);
    acc[filter] = isHidden
      ? getFilterDefaultValue({ conf, isMin, isMax })
      : filters[filter];
    return acc;
  }, {});
};

export const resetPriceFilters = (filters) => {
  if (!['case', 'nuove-costruzioni'].includes(filters.propertyTypeGroup)) {
    if (
      filters.paymentMin !== DEFAULT_FILTERS_CONFIGURATION.payment.defaultMinValue
      || filters.paymentMax !== DEFAULT_FILTERS_CONFIGURATION.payment.defaultMaxValue
    ) {
      filters.paymentMin = DEFAULT_FILTERS_CONFIGURATION.payment.defaultMinValue;
      filters.paymentMax = DEFAULT_FILTERS_CONFIGURATION.payment.defaultMaxValue;
      filters.priceType = DEFAULT_FILTERS_CONFIGURATION.priceType.defaultValue;
    }
    if (
      (
        filters.propertyTypeGroup === 'stanze'
        || (
          filters.propertyTypes
          && filters.propertyTypes.length === 1
          && ['Attività/Licenza (con o senza mura)', 'attivita-licenza-commerciale'].includes(filters.propertyTypes[0])
        ) || (
          filters.propertyTypeGroup === 'commerciale'
          && filters.propertyTypes
          && filters.propertyTypes.length === 0
        )
      )
      && (
        filters.mqpriceMin !== DEFAULT_FILTERS_CONFIGURATION.mqprice.defaultMinValue
        || filters.mqpriceMax !== DEFAULT_FILTERS_CONFIGURATION.mqprice.defaultMaxValue        
      ) 
    ) {
      filters.mqpriceMin = DEFAULT_FILTERS_CONFIGURATION.mqprice.defaultMinValue;
      filters.mqpriceMax = DEFAULT_FILTERS_CONFIGURATION.mqprice.defaultMaxValue;
      filters.priceType = DEFAULT_FILTERS_CONFIGURATION.priceType.defaultValue;
    }
  }
  if(filters.propertyTypeGroup !== 'commerciale') { 
    filters.license_type_groups = [];
  }

};

const computeSearchFilters = (filters, initial = false) => {
  const newFilters = JSON.parse(JSON.stringify(filters));

  if (!initial) {
    newFilters.propertyTypeGroup = newFilters.category && newFilters.category !== 'residenziale'
      ? newFilters.category
      : newFilters.propertyTypeGroup;
  }

  if (newFilters.category === '') {
    newFilters.propertyTypeGroup = '';
  }

  newFilters.channel = newFilters.category && NO_BUY_PTYPEGROUPS.indexOf(newFilters.category) > -1 && newFilters.channel !== 'affitto'
    ? 'affitti'
    : newFilters.channel;

  if (newFilters.propertyTypeGroup === 'nuove-costruzioni') {
    newFilters.exclude_under_construction = false;
  }

  /***
   * 
   * DA GUARDARE
   * 
   */
  // if (!('lift_level' in newFilters) && 'lift_level' in newFilters) {
  //   delete newFilters.lift_level;
  // }

  resetPriceFilters(newFilters);

  return resetHiddenFilters(newFilters);
};

export default computeSearchFilters;
